import { resolvePath } from "@utils/resolvePath";
import { useContext } from "react";
import { Context } from "@components/useContext/context";
import {
  Container,
  LieHeader,
  LieNumber,
  LieQuote,
  Divider,
  MainHeading,
  InfoCard,
  InfoHeading,
  DealershipsBox,
  DealershipsTitle,
  DealershipItem,
  DealershipText,
  HorizontalDivider,
  ViewAllLink
} from "./styles";
import { SDUIImageTag } from "@components/common/image";

const DealershipLieCard = (props: any) => {
  const {
    is_visible = true,
    dealershipLieNumber,
    dealershipLieQuote,
    dealershipLieMainText,
    dealershipLieContactText,
    dealershipLieImage,
    fallbackImage = "/images/Myth1dweb.svg",
    fallBackImageMobile = "/images/Myth1mweb.svg",
    onDealershipLieCardClick
  } = props;
  const { isDesktop } = useContext(Context);
  return (
    <>
      {is_visible && (
        <Container>
          <LieHeader>
            <LieNumber>{dealershipLieNumber}</LieNumber>
            <LieQuote
              dangerouslySetInnerHTML={{
                __html: dealershipLieQuote
              }}
            ></LieQuote>
          </LieHeader>
          <Divider />
          <MainHeading
            dangerouslySetInnerHTML={{
              __html: dealershipLieMainText
            }}
          ></MainHeading>
          <div onClick={onDealershipLieCardClick}>
            <SDUIImageTag
              is_visible={true}
              id="image-id"
              src={resolvePath(dealershipLieImage || isDesktop ? fallbackImage : fallBackImageMobile)}
              styles={{ width: "100%", height: "auto" }}
              actions={{}}
              alt="description"
            />
          </div>
        </Container>
      )}
    </>
  );
};

export default DealershipLieCard;
